import React from "react";
import { MySubscriptionComponent } from "./my-subscription.component";

export const MySubscriptionPage = () => <MySubscriptionComponent />;
